<div class="row">
  <div class="col-12 pt-1">
    <mat-form-field appearance="outline" class="no-subscript">
      <mat-label>Document Type</mat-label>
      <input
        matInput
        placeholder="Select Document Type"
        #typeInput
        [matAutocomplete]="autoType"
        [formControl]="typeCtrl"
        #trigger="matAutocompleteTrigger"
      />
      <mat-autocomplete
        #autoType="matAutocomplete"
        (optionSelected)="selectedType($event)"
        #typeAutocomplete
        [displayWith]="displayObject"
      >
        <mat-option *ngFor="let type of documentTypesFiltered" [value]="type">
          {{ type.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</div>
<div class="container left-table-container pt-1">
  <mat-tree
    [dataSource]="dataSource"
    [treeControl]="treeControl"
    cdkDropList
    (cdkDropListDropped)="drop($event)"
  >
    <mat-tree-node
      *matTreeNodeDef="let node"
      matTreeNodeToggle
      matTreeNodePadding
      cdkDrag
      [cdkDragData]="node"
      (mouseenter)="dragHover(node)"
      (mouseleave)="dragHoverEnd()"
      (cdkDragStarted)="dragStart()"
      (cdkDragReleased)="dragEnd()"
    >
      <button mat-icon-button disabled></button>
      <mat-icon color="accent">{{ node.icon }}</mat-icon>
      <div class="node" (click)="nodeClicked(node)">{{ node.name }}</div>
    </mat-tree-node>

    <mat-tree-node
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding
      cdkDrag
      [cdkDragData]="node"
      (mouseenter)="dragHover(node)"
      (mouseleave)="dragHoverEnd()"
      (cdkDragStarted)="dragStart()"
      (cdkDragReleased)="dragEnd()"
    >
      <button
        mat-icon-button
        matTreeNodeToggle
        [attr.aria-label]="'toggle ' + node.filename"
      >
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
        </mat-icon>
      </button>
      <mat-icon color="primary">{{ node.icon }}</mat-icon>
      <div
        class="node d-flex align-items-center justify-content-between"
        (click)="nodeClicked(node)"
        [ngClass]="{
          'bluex bold': node?.status == 1,
          grayx: node?.status == 0,
          yellowx: node?.status == -1,
          selected: tableId == node.tableId && node.level == 0
        }"
      >
        {{ node.name
        }}<mat-icon
          class="yellowx ml-2"
          *ngIf="editing && node.tableId == tableId"
          >edit</mat-icon
        >
      </div>
    </mat-tree-node>
  </mat-tree>
</div>
